import { get } from "svelte/store";
import { sendLog } from "../services/sendLog";
import { isAlticeStore } from "../stores/isAlticeStore";
import { roleStore } from "../stores/roleStore";
export function buildLog({ roomId, status, page, message, comment, satisfaction }) {
    sendLog({
        room: roomId,
        status,
        page,
        message,
        comment,
        satisfaction,
        distributeur: get(isAlticeStore) ? "Altice" : "SFR",
        role: get(roleStore)
    });
}
